import React from 'react';
import Reflux from 'reflux';
import UIRegions from 'shared/constants/UIRegions';
import Messages from 'shared/constants/Messages';
import EventShowListStore from 'flux/stores/EventShowListStore';
import CuesheetStore from 'flux/stores/cuesheet/CuesheetStore';
import EventViewStore from 'flux/stores/EventViewStore';
import GuestPassStore from 'flux/stores/GuestPassStore';
import UserSessionStore from 'flux/stores/UserSessionStore';
import GuestPassModal from 'main/components/event/guestPassModal';

export default React.createClass({
  displayName: 'GuestPassModal',

  mixins: [
    Reflux.connectFilter(CuesheetStore, 'show', (state) => state.get('show')),
    Reflux.connectFilter(CuesheetStore, 'defaultColumnOrder', (state) =>
      state.get('defaultColumnOrder'),
    ),
    Reflux.connectFilter(CuesheetStore, 'fullColumns', (state) =>
      state.get('fullColumns'),
    ),
    Reflux.connectFilter(CuesheetStore, 'columnOrderGuest', (state) =>
      state.get('columnOrderGuest'),
    ),
    Reflux.connectFilter(CuesheetStore, 'columnsGuestPass', (state) =>
      state.get('columnsGuestPass'),
    ),
    Reflux.connectFilter(EventShowListStore, 'showList', (state) =>
      state.get('shows'),
    ),
    Reflux.connect(EventViewStore, 'event'),
    Reflux.connect(UserSessionStore, 'user'),
    Reflux.connect(GuestPassStore, 'guestPass'),
  ],

  getInitialState() {
    return {};
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  render() {
    const params = this.context.router.state.params;
    const { teamId, eventId, showId } = params;

    return (
      <GuestPassModal
        modalType={UIRegions.GuestPass}
        title={showId ? 'Guest Pass' : 'Event Guest Pass'}
        description={
          showId
            ? Messages.guestPassShowDescription
            : Messages.guestPassEventDescription
        }
        {...this.state}
        {...{ teamId, eventId, showId }}
      />
    );
  },
});
